export default (obj) => (
  Object.keys(obj).reduce((seq, key) => (
    !obj[key] ? seq : { ...seq, [key]: obj[key] }
  ), {})
);
